import { request, config } from "./repository.js";

export function getLayout(params) {
    const paramsStr = (new URLSearchParams(params)).toString();
    return request("get", config.newsItemUrl.replace("{params}", paramsStr), null, {
        credentials: "include",
    });
}
